import type { CampaignModel, CampaignQuoteModel, OrderItemModel } from '@models/types'

type SortByPriorityCampaignsParams = {
  entities: (CampaignModel[] | CampaignQuoteModel[] | OrderItemModel[]),
  selectedPriorityUserId: number,
  sortKey?: string,
}

export const sortByPriorityCampaigns = (
  params: SortByPriorityCampaignsParams,
) => {
  const { entities, selectedPriorityUserId, sortKey = 'cache_key desc' } = params

  entities.sort((a, b) => {
    const sortAPreferred = a.priority_campaign_user_ids?.includes(selectedPriorityUserId)
    const sortBPreferred = b.priority_campaign_user_ids?.includes(selectedPriorityUserId)

    if (sortAPreferred && !sortBPreferred) return -1
    if (!sortAPreferred && sortBPreferred) return 1

    if (sortKey === 'cache_key desc'){
      return a.cache_key > b.cache_key ? -1 : 1
    }

    return 0
  })

  return entities
}

export default sortByPriorityCampaigns
